import Image from 'next/image'

import ButtonContactUsAccountDeletion from './button-contact-us-account-deletion'

import { BackToSurveyListButton, Footer } from '@/components'
import ButtonCancelAccountDeletion from '@/components/pages/account-deletion/button-cancel-account-deletion'
import { approved, rejected } from '@/libs/constants/images-library'

export enum EAccountDeletionState {
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  DELETED = 'deleted',
}

type TAccountDeletionProps = {
  state: EAccountDeletionState
  daysLeftForDeletion?: number
}

const states = {
  pending: {
    image: rejected,
    title: 'Account Pending Deletion',
    description: (daysLeftForDeletion?: number) =>
      `Your account will be deleted in ${
        daysLeftForDeletion || 14
      } days. You can cancel your account deletion if you changed your mind.`,
    cta: () => <ButtonCancelAccountDeletion />,
  },
  cancelled: {
    image: approved,
    title: 'Delete Account Cancelled',
    description: () =>
      'Your account deletion has been successfully cancelled. You can continue to access your account and participate in our surveys.',
    cta: () => <BackToSurveyListButton />,
  },
  deleted: {
    image: rejected,
    title: 'Account Deleted',
    description: () =>
      'You can’t access your account because you have requested to delete the account from this account or a linked account.',
    cta: () => <ButtonContactUsAccountDeletion />,
  },
}

export default function AccountDeletion({
  state,
  daysLeftForDeletion,
}: Readonly<TAccountDeletionProps>) {
  const { image, title, description, cta } = states[state]

  return (
    <div className='bg-pop-gray-8'>
      <main className='flex h-nav-screen items-center justify-center'>
        <div className='w-full md:flex-grow'>
          <form className='mx-auto flex max-w-md flex-col items-center gap-3 rounded-lg px-5'>
            <Image src={image.src} alt={image.alt} width={160} height={160} />
            <h1 className='text-center text-2xl font-semibold'>{title}</h1>
            <p className='mb-3 text-center text-sm font-normal'>
              {description(daysLeftForDeletion)}
            </p>
            {cta()}
          </form>
        </div>
      </main>
      <Footer />
    </div>
  )
}
